import { createFileRoute } from "@tanstack/react-router";

import DeliveriesOverview from "@/components/[routes]/deliveries/deliveries-overview";

export const Route = createFileRoute("/_secure/deliveries/")({
  component: DeliveriesOverview,
});
